import { useState, useEffect } from "react";
import {
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
  Paper,
} from "@mui/material";
import axios from "../../../config/axios";
import FormLabel from "../../../components/FormLabel";
import CommonDialog from "../../../components/CommonDialog";

const ManageLinkedProfile = (props) => {
  const [btnLoader, setBtnLoader] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [userList, setUserList] = useState([]);

  // other functions
  const handleCloseModal = () => {
    props.setOpen(false);
  };

  const handleToggle = (list, setList, id) => {
    const tempList = [...list];
    if (tempList.includes(id)) {
      const index = tempList.indexOf(id);
      tempList.splice(index, 1);
    } else {
      tempList.push(id);
    }
    setList(tempList);
  };

  const handleUpdate = () => {
    setBtnLoader(true);
    const params = {
      profileId: props.data._id,
    };

    const body = {
      userList,
      adminList,
    };

    axios
      .put("employee-profile/update-ownership", body, { params })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status) {
            props.setAlertVariant("success");
            props.setAlertMessage(res.data.message);
            props.setAlert(true);
            handleCloseModal();
            props.getList();
          } else {
            if (res.data.type === "error") {
              props.setAlertVariant("error");
              props.setAlertMessage(res.data.error?.message);
              props.setAlert(true);
            }
          }
        }
        setBtnLoader(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (props.data) {
      setAdminList(props.data.assignedToAdmins?.map((adm) => adm._id) || []);
      setUserList(props.data.assignedToUsers?.map((usr) => usr._id) || []);
    }
  }, []);

  return (
    <CommonDialog
      open={props.open}
      title="Manage Linked Profile"
      submitLabel="Update"
      loading={btnLoader}
      onSubmit={handleUpdate}
      onClose={handleCloseModal}
    >
      <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
        <Box style={{ padding: "10px" }}>
          <Grid container spacing={1}>
            {props.data?.assignedToAdmins?.length ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormLabel title="Admins" sx={{ fontSize: "16px" }} />
                <FormGroup row>
                  {props.data?.assignedToAdmins?.map((admin) => (
                    <FormControlLabel
                      control={<Checkbox />}
                      label={admin.name}
                      checked={adminList.includes(admin._id)}
                      onClick={() =>
                        handleToggle(adminList, setAdminList, admin._id)
                      }
                    />
                  ))}
                </FormGroup>
              </Grid>
            ) : null}
            {props.data?.assignedToUsers?.length ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormLabel title="Users" sx={{ fontSize: "16px" }} />
                <FormGroup style={{ display: "flex" }}>
                  {props.data?.assignedToUsers?.map((user) => (
                    <FormControlLabel
                      control={<Checkbox />}
                      label={user.name}
                      checked={userList.includes(user._id)}
                      onClick={() =>
                        handleToggle(userList, setUserList, user._id)
                      }
                    />
                  ))}
                </FormGroup>
              </Grid>
            ) : null}
          </Grid>
        </Box>
      </Paper>
    </CommonDialog>
  );
};

export default ManageLinkedProfile;
